import Link from 'next/link'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import arrowRightImg from '../../assets/arrow-right.svg'
import { getPopularHashtags } from '../../redux/actions/PopularHashTagsAction'
import {
  CardsRowWrapper,
  CardsScrollableWrapper,
  HashtagCard,
  ScrollButton
} from './CardsRow.styles'

const FORWARD_BUTTON = 'FORWARD'
const BACK_BUTTON = 'BACK'
const BOTH_BUTTONS = 'BOTH'

export const CardsRow = () => {
  const dispatch = useDispatch()
  const { hashtags } = useSelector(state => {
    return state.popularHashTags.popularHashTags
  })
  const rowWrapper = useRef(null)
  const [showButtons, setShowButtons] = useState(FORWARD_BUTTON)

  const scroll =
    (offset = 500) =>
    () => {
      const el = rowWrapper.current
      if (el) {
        el.scrollTo({ left: el.scrollLeft + offset, behavior: 'smooth' })
      }
    }

  useEffect(() => {
    dispatch(getPopularHashtags())
  }, [dispatch])

  useEffect(() => {
    let listener = e => {
      const el = e.target

      if (el.scrollLeft === 0) setShowButtons(FORWARD_BUTTON)
      if (el.scrollLeft > 0) setShowButtons(BOTH_BUTTONS)
      if (el.scrollWidth - el.offsetWidth - el.scrollLeft === 0) {
        setShowButtons(BACK_BUTTON)
      }
    }

    const ref = rowWrapper.current
    ref?.addEventListener('scroll', listener)

    return () => {
      ref?.removeEventListener('scroll', listener)
    }
  }, [rowWrapper])

  return (
    <CardsRowWrapper>
      {[FORWARD_BUTTON, BOTH_BUTTONS].includes(showButtons) && (
        <ScrollButton onClick={scroll(500)}>
          <img src={arrowRightImg} alt="" />
        </ScrollButton>
      )}
      {[BACK_BUTTON, BOTH_BUTTONS].includes(showButtons) && (
        <ScrollButton back onClick={scroll(-500)}>
          <img src={arrowRightImg} alt="" />
        </ScrollButton>
      )}
      <CardsScrollableWrapper ref={rowWrapper}>
        {(hashtags || []).map(hashtag => (
          <Link href={`/hashtag/${hashtag.title}`}>
            <HashtagCard key={hashtag.title}>
              <span>#{hashtag.title}</span>
              <div />
              <img src={hashtag.previewImageUrl} alt="" />
            </HashtagCard>
          </Link>
        ))}
      </CardsScrollableWrapper>
    </CardsRowWrapper>
  )
}
